import { compose, get, includes, intersection } from 'lodash/fp';
import { createSelector } from 'reselect';
import { array } from 'fp-ts';
import { ifElse, gtOne, getStringProp } from '@mews/fp';
import { createOptionsSelector } from '@mews-commander/utils';
import {
    getAllServiceIdsSelectableBySingleDay,
    serviceCreateOptionsProps,
} from '@mews-commander/legacy-entities/src/ducks/services';
import { localizedEntities } from '@mews-commander/legacy-entities/src/ducks/utils';
import { moduleSelector } from '../module';
import { getSelectedEntityServiceIds, getSelectedEnterpriseServices } from './entities';
import { sameDayOrder } from './order';

const servicesSelector = createSelector(moduleSelector, get('services'));
const getFetchedServices = createSelector(servicesSelector, get('fetchedServices'));
export const isServiceFetched = createSelector(getStringProp('serviceId'), getFetchedServices, includes);

export const getSelectedEntityServiceIdsForSingleDaySelection = createSelector(
    getSelectedEntityServiceIds,
    getAllServiceIdsSelectableBySingleDay,
    intersection
);

export const getSelectedEntityTimeUnitServiceIds = ifElse(
    sameDayOrder,
    getSelectedEntityServiceIdsForSingleDaySelection,
    getSelectedEntityServiceIds
);

export const getHasMultipleServices = compose(gtOne, array.size, getSelectedEntityServiceIds);

export const getSelectedEnterpriseServiceOptions = createOptionsSelector(
    localizedEntities(getSelectedEnterpriseServices, 'names', 'localizedName'),
    serviceCreateOptionsProps
);
